<template>
  <div>
    <check-selector-collapse
      :icon="icon"
      :label="label"
      :options="options"
      @checked="handleChecked"
    />
  </div>
</template>

<script>
import CheckSelectorCollapse from '../../../../commons/forms/CheckSelectorCollapse.vue';
import laboratorios from '@/api/laboratorios.api';
import { mapActions } from 'vuex';
import { mapState } from 'vuex';

export default {
  name: 'LaboratoriosSelector',
  components: { CheckSelectorCollapse },
  extends: laboratorios,
  props: {
    label: {
      type: String,
      default: 'Laboratorios',
    },
    icon: {
      type: String,
      default: 'icon-pharmacy',
    },
  },
  data() {
    return {
      options: [],
      selectedItems: [],
      selectedItemsSet: new Set(),
    };
  },
  computed: {
    ...mapState('filters', ['filtros']),
  },
  watch: {
    'filtros.laboratorios': function () {
      this.syncSelectedItemsWithStore();
    },
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    loadItems() {
      let loadPromise = new Promise((resolve) => {
        this.getLaboratorios(resolve, this.request);
      });

      loadPromise.then((data) => {
        this.options = data.map((item) => ({
          text: item.nombre,
          value: item.id_laboratorio,
          selected: false,
        }));
      });
    },
    syncSelectedItemsWithStore() {
      const laboratoriosSeleccionados = this.filtros.laboratorios || [];

      const selectedItemsSet = new Set();

      laboratoriosSeleccionados.forEach((lab) => {
        selectedItemsSet.add(String(lab.codigo));
        selectedItemsSet.add(String(lab.value));
      });

      this.options = this.options.map((item) => {
        item.selected = selectedItemsSet.has(String(item.value));
        return item;
      });
    },
    handleChecked(newSelectedItems) {
      const laboratoriosSeleccionados = this.filtros.laboratorios || [];

      if (!Array.isArray(newSelectedItems)) {
        newSelectedItems = [newSelectedItems];
      }

      newSelectedItems.forEach((selected) => {
        const valueToCheck = String(selected.value);

        if (selected.selected) {
          this.selectedItemsSet.add(valueToCheck);
        } else {
          this.selectedItemsSet.delete(valueToCheck);
        }
      });

      let selectedItemsArray = Array.from(this.selectedItemsSet);

      laboratoriosSeleccionados.forEach((item) => {
        const valueToCheck = item.value
          ? String(item.value)
          : String(item.codigo);

        if (!selectedItemsArray.includes(valueToCheck)) {
          selectedItemsArray.push(valueToCheck);
        }
      });

      newSelectedItems.forEach((selected) => {
        if (!selected.selected) {
          const valueToCheck = String(selected.value);
          selectedItemsArray = selectedItemsArray.filter(
            (item) => item !== valueToCheck
          );
        }
      });

      const selectedItems = selectedItemsArray.map((value) => ({
        value,
        selected: true,
      }));

      this.updateFiltros({
        filtro: 'laboratorios',
        items: selectedItems,
      });
      // console.log(newSelectedItems);
      // this.$emit('update_filters', newSelectedItems);
      this.emitSelectedItems();
    },

    emitSelectedItems() {
      const selectedItemsArray = Array.from(this.selectedItemsSet);
      this.$emit('update_filters', selectedItemsArray);
    },

    ...mapActions('filters', ['updateFiltros']),
  },
};
</script>
